import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, dateColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P410List2({ dataTable, dataInfoA, action, onChangeAction, searchLev2, setSearchLev2 }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);

    const actionTab = (data) => {
        setSearchLev2({
            ...searchLev2,
            topicNo: data ? data.topicNo : 0,
            versionNo: data ? data.versionNo : dataInfoA.versionNo,
        });

        onChangeAction(3, data ? "แก้ไข" : "บันทึก");
    };

    const headerLabel = <span className="hidden-responsive">เพิ่มหัวข้อพิจารณา</span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-plus"
                // onClick={() => setDialog({ dialog: true, action: 'บันทึก' })}
                onClick={() => actionTab()}
                disabled={action && action.action === "บันทึก" ? true : false}
                autoFocus
            />
            {/* <span className="p-input-icon-left span-responsive">
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" className="btn-responsive" onInput={(e) => setGlobalFilter(e.target.value)} />
            </span> */}
        </div>
    );
    return (
        <div className="datatable-responsive-modify">
            <DataTable
                value={dataTable}
                dataKey="id"
                paginator
                first={pageConf.first}
                rows={pageConf.rows}
                onPage={(e) => onPageChange(e, setPageConf)}
                rowsPerPageOptions={rowsPerPageOptions()}
                paginatorTemplate={paginatorTemplate()}
                currentPageReportTemplate={currentPageReportTemplate()}
                header={header}
                // globalFilter={globalFilter}
                emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                selectionMode="single"
            >
                <Column sortable field="topicNo" header="ข้อ" body={(e) => normalColumn(e, "topicNo", "ข้อ")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="topicDesc" header="หัวข้อพิจารณา" body={(e) => normalColumn(e, "topicDesc", "หัวข้อพิจรณา")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="criteriaWeight" header="น้ำหนัก" body={(e) => normalColumn(e, "criteriaWeight", "น้ำหนัก")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="updateUserName" header="ผู้บันทึก/แก้ไข" body={(e) => normalColumn(e, "updateUserName", "ผู้บันทึก/แก้ไข")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="updateDt" header="วันที่-เวลาที่แก้ไข" body={(e) => dateColumn(e, true, "updateDt", "วันที่-เวลาที่แก้ไข")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                <Column header="แก้ไข" body={(e) => actionEditColumn(e, actionTab)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
            </DataTable>
        </div>
    );
}
